export default [
    {
        path: '/',
        component: () => import(/* webpackChunkName: "about" */ '../views/home/Index.vue')
    },
    {
        path: '/product',
        component: () => import('../views/home/Product.vue'),
    },
    {
        path: '/user',
        component: () => import('../views/home/User.vue'),
    },
    {
        path: 'aggregate/index',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/aggregate/Index.vue')
    },
]
